import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

import { formatImage } from '@ifeng-fe/public_method';

import { callApp } from '@ifeng-fe/callapp';

import follow from './follow.png';

import { h5PageCount } from 'ThreeTerminal_utils';

class WeMediaInfo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {};

    handleClickFollow = () => {
        const {
            content: { base62Id },
        } = this.props;

        const clickCount = {
            behavior: 'action',
            type: 'btnsub',
            other: {
                ref: `survey_${base62Id}`,
                kind: 'survey',
            },
        };

        h5PageCount([clickCount]);

        callApp({
            client: 'newsApp',
            docType: 'survey',
            pid: `${base62Id}`,
            // pid: `https://nine.ifeng.com/surveydetail?sid=${base62Id}`,
        });
    };

    render() {
        const {
            content: { fhhAccountDetail },
        } = this.props;

        return (
            <div className={styles.weMediaInfo}>
                <div className={styles.headImg}>
                    <img src={fhhAccountDetail.logo && formatImage(fhhAccountDetail.logo, 96, 96, 100)} alt="" />
                </div>
                <div className={styles.info}>
                    <div className={styles.weMediaName}>{fhhAccountDetail.weMediaName}</div>
                    <div className={styles.description}>{fhhAccountDetail.description}</div>
                </div>
                <div className={styles.follow} onClick={this.handleClickFollow}>
                    <img src={follow} alt="" />
                    关注
                </div>
            </div>
        );
    }
}

export default WeMediaInfo;
